// services/nif.js
import axiosInstance from './axiosInstance';

const NIF_API_URL = '/nif';

const nifService = {
  async get(nif) {
    try {
      const response = await axiosInstance.get(`${NIF_API_URL}/get.php?nif=${nif}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export default nifService;
